/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateBusinessBillingBody
 */
export interface UpdateBusinessBillingBody {
    /**
     * 
     * @type {string}
     * @memberof UpdateBusinessBillingBody
     */
    stripeAccountId: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateBusinessBillingBody
     */
    currency: string;
}

/**
 * Check if a given object implements the UpdateBusinessBillingBody interface.
 */
export function instanceOfUpdateBusinessBillingBody(value: object): value is UpdateBusinessBillingBody {
    if (!('stripeAccountId' in value) || value['stripeAccountId'] === undefined) return false;
    if (!('currency' in value) || value['currency'] === undefined) return false;
    return true;
}

export function UpdateBusinessBillingBodyFromJSON(json: any): UpdateBusinessBillingBody {
    return UpdateBusinessBillingBodyFromJSONTyped(json, false);
}

export function UpdateBusinessBillingBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateBusinessBillingBody {
    if (json == null) {
        return json;
    }
    return {
        
        'stripeAccountId': json['stripeAccountId'],
        'currency': json['currency'],
    };
}

export function UpdateBusinessBillingBodyToJSON(json: any): UpdateBusinessBillingBody {
    return UpdateBusinessBillingBodyToJSONTyped(json, false);
}

export function UpdateBusinessBillingBodyToJSONTyped(value?: UpdateBusinessBillingBody | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'stripeAccountId': value['stripeAccountId'],
        'currency': value['currency'],
    };
}

